import React, { useMemo } from 'react';
import { Box, Inscription, ListItem, ListItemBase } from '@common-fe/common-fe';

import { TerminationPlanListItem } from '@/modules/employer/components/EmployerTermination/EmployerTerminationModalForms/TerminationPlanListItem';
import TransactionsListHeader from '@/modules/transaction/TransactionsList/TransactionsListHeader/TransactionsListHeader';

const coveragesHeaders: ListItemBase[] = [
  {
    key: 'planName',
    title: 'Plan name',
    flex: 1.7,
  },
  {
    key: 'endOfCoverage',
    title: 'End of coverage',
    flex: 1.1,
  },
  {
    key: 'lastDayToSubmitClaim',
    title: 'Last day to submit claim',
    flex: 1,
  },
];

const plansHeaders: ListItemBase[] = [
  {
    key: 'planName',
    title: 'Plan name',
    flex: 2.5,
  },
  {
    key: 'planStartDate',
    title: 'Plan start date',
    flex: 1,
  },
  {
    key: 'planEndDate',
    title: 'Plan end date',
    flex: 1,
  },
];

export enum Mode {
  COVERAGES = 'coverages',
  PLANS = 'plans',
}

interface Props {
  mode: Mode;
  coveragesList?: ListItem[];
  planList?: ListItem[];
}

export const PlanTerminationCoverageDatesForm: React.FC<Props> = ({
  mode,
  coveragesList,
  planList,
}) => {
  const currentList = useMemo(() => {
    if (coveragesList && coveragesList.length > 0 && mode === Mode.COVERAGES) {
      return coveragesList;
    }
    if (planList && planList.length > 0 && mode === Mode.PLANS) {
      return planList;
    }
    return [];
  }, [coveragesList, planList, mode]);

  const currentHeaders = useMemo(() => {
    if (mode === Mode.COVERAGES) {
      return coveragesHeaders;
    }
    if (mode === Mode.PLANS) {
      return plansHeaders;
    }
    return [];
  }, [mode]);

  return (
    <Box
      data-testid={`PlanTerminationPlanList_container-${mode}`}
      round="container1Round"
      background="canvas"
      pad="spacing24"
      border={{ color: 'border2' }}
      id={`PlanTerminationPlanList_container-${mode}`}
    >
      {mode === Mode.COVERAGES ? (
        <Box
          justify="center"
          height={{ min: '40px', max: '40px'}}
          margin={{ bottom: 'spacing16' }}
      >
        <Inscription size="20px">
          Termination Coverage Dates
        </Inscription>
        </Box>
      ) : null}

      <Box data-testid="PlanTerminationPlanList_table">
            <TransactionsListHeader
              items={currentHeaders}
              style={{
                paddingInline: '12px',
                paddingBlock: '6px',
                marginBottom: 0,
                borderRadius: '8px',
              }}
            />

            {/* {currentList.map((item) => (
              <FlexListItem
                key={item.id}
                fields={item.fields}
                id={item.id}
                hasNext
                rowWrapperStyle={{
                  marginTop: '8px',
                }}
                rowStyle={{
                  border: 'none',
                  paddingInline: '12px',
                  paddingBlock: 0,
                  minHeight: '40px',
                  boxShadow: 'none',
                }}
              />
            ))} */}
            {currentList.map((item) => (
                <TerminationPlanListItem
                  key={item.id}
                  fields={item.fields}
                  id={item.id}
                  editMode
                  // rowWrapperStyle={{
                  //   marginTop: '2px',
                  // }}
                  // rowStyle={{
                  //   border: 'none',
                  //   paddingInline: '12px',
                  //   paddingBlock: 0,
                  //   minHeight: '40px',
                  //   boxShadow: 'none',
                  //   alignItems: 'center',
                  // }}
                />
            ))}
      </Box>
    </Box>
  );
};
